export const formSubmitValueMapper = (data = {}) => ({
  id_item_checklist: data?.id_item_checklist ?? undefined,
  jenis_checklist: data?.jenis_checklist,
  nama_item_checklist: data?.nama_item_checklist,
  keterangan: data?.keterangan,
});
